import {
  closeSnackbar, enqueueSnackbar, SnackbarKey, VariantType,
} from 'notistack';
import { useTranslation } from 'react-i18next';
import config from '../../../../../../config';
import ActivityChangeContent from '../Components/ActivityChangeContent';
import renderActivityChangeAction from '../Components/renderActivityChangeAction';

type MessageKeys = 'activityChange' | 'sessionTimeout' | 'vadEvent' | 'noVadDetected';

export default function useEnqueueTrigger() {
  const { t } = useTranslation('notifications');
  function enqueueTrigger(
    key: MessageKeys,
    subkey: string,
    callback: () => void,
    variant: VariantType = 'info',
  ): void | (() => void) {
    let snackbarKey: SnackbarKey | null = null;
    const autoHideDuration: number = config.Live.Audio[key][subkey];
    const timeout = setTimeout(() => {
      callback();
      if (snackbarKey) closeSnackbar(snackbarKey);
    }, autoHideDuration);

    snackbarKey = enqueueSnackbar(
      ActivityChangeContent({
        duration: autoHideDuration,
        title: t(`${key}.${subkey}.title`),
        body: t(`${key}.${subkey}.body`),
        variant,
      }),
      {
        variant,
        autoHideDuration,
        action: renderActivityChangeAction(
          () => {
            clearTimeout(timeout);
          },
          t(`${key}.${subkey}.keep`),
        ),
        hideIconVariant: true,
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        },
      },
    );

    if (key !== 'noVadDetected') return undefined;
    return () => {
      clearTimeout(timeout);
      if (snackbarKey) closeSnackbar(snackbarKey);
    };
  }

  return enqueueTrigger;
}
